import React from "react";
import { Button, ButtonGroup, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload } from "@fortawesome/fontawesome-free-solid";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

class PackagesActionCell extends React.Component {
  render() {
    return (
      <Row style={{ marginLeft: "-3px", float: "right" }}>
        <ButtonGroup size="sm">
          <Button
            onClick={this.props.onUpload}
            id="dropdown-basic-button"
            className="btn-green"
          >
            <FontAwesomeIcon icon={faUpload} />
          </Button>
          <Button
            onClick={this.props.onDelete}
            id="dropdown-basic-button2"
            className="btn-red"
          >
            <FontAwesomeIcon icon={faTrash} />
          </Button>
        </ButtonGroup>
      </Row>
    );
  }
}

export default withTranslation()(PackagesActionCell);
